require('./accountIntervenerRemoveSuccess.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { OKLink } = require('commonsComponents/OKLink');
// @ helpers
const {FormattedText, formatText} = require('core/i18n').i18n;
// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

class AccountIntervenerRemoveSuccess extends React.Component {

    componentWillUnmount() {
        this.props.clearIntervenerRemoval();
    }

    render() {
        const { immAccount, immIntervener } = this.props;
        const exitLink = `/myprofile/accounts/${immAccount.get('accountId')}/details`;
        const title = formatText('accountInterveners-successMessage', [
            immIntervener.get('name'),
            immIntervener.get('type')
        ]);

        return (
            <WizardSuccess
                successMessage={title}
            >
                <footer className="account-intervener-remove-success__footer">
                    <OKLink modifier="emphasize" to={exitLink}>
                        <FormattedText value="accountInterveners-goBack" />
                    </OKLink>
                </footer>
            </WizardSuccess>
        );
    }
}

AccountIntervenerRemoveSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immIntervener: PropTypes.object.isRequired,
    clearIntervenerRemoval: PropTypes.func.isRequired
};

module.exports = AccountIntervenerRemoveSuccess;
